import { render, staticRenderFns } from "./swiper-pagination.vue?vue&type=template&id=262f430c&scoped=true&"
import script from "./swiper-pagination.vue?vue&type=script&lang=ts&"
export * from "./swiper-pagination.vue?vue&type=script&lang=ts&"
import style0 from "./swiper-pagination.vue?vue&type=style&index=0&id=262f430c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262f430c",
  null
  
)

export default component.exports